import { useEffect } from "react";
import { message } from "antd";
import { validateToken } from "services/authService";

export const useAuthHeartbeat = ({
  isLoggedIn,
  token,
  logout,
  intervalMs = 2 * 60 * 1000, // every 2 minutes
}) => {
  useEffect(() => {
    if (!isLoggedIn || !token) return;

    let cancelled = false;

    const check = async () => {
      try {
        await validateToken(token);
      } catch (err) {
        if (!cancelled) {
          message.warning("Session expired. Please log in again.");
          logout();
        }
      }
    };

    check(); // immediate check
    const timer = setInterval(check, intervalMs);

    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [isLoggedIn, token, logout, intervalMs]);
};